import { useSignOut, useUserData } from "@nhost/react";
import { SidebarData, SideBarProfile, title } from "./SlidebarData";
import { LogOut } from "lucide-react";
import { Link, NavLink, useNavigate } from "react-router-dom";


import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

function NavBar() {

  const user = useUserData(); // Récupération des infos de l'utilisateur
  const { signOut } = useSignOut();
  // Vérifier si l'utilisateur a le rôle "UserAdmin"
  const isAdmin = user?.roles?.includes("UserAdmin");

  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate("/sign-in");
  };

  return (
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container fluid>
        <Navbar.Brand as={Link} to="/">{title}</Navbar.Brand>
        <img src="diren.png" alt="Logo" className="navbar-logo" />
          <Nav className="me-auto">
            {SidebarData.filter(
                          (item) => isAdmin || item.title !== "Administration"
                        ).map((item) => (
                            <Nav.Link as={Link} to={item.path}>
                              {item.icon}
                              <span>{item.title}</span>
                            </Nav.Link>
            ))}
          </Nav>

         
        <Nav className="ms-auto align-items-center d-flex gap-3">
          <Navbar.Text className="d-none d-lg-block">
                Connecté en tant que: <strong>{user?.displayName}</strong>
          </Navbar.Text>
          {SideBarProfile.map((item) => (
                            <Nav.Link as={Link} to={item.path}>
                              {item.icon}
                              <span>{item.title}</span>
                            </Nav.Link>
            ))}
          <Nav.Link as={Link} to="/" onClick={handleSignOut}>
                <LogOut className="icon-small" />
                <span>Déconnexion</span>
          </Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
}

export default NavBar;